import { Box } from '@material-ui/core'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { Login } from './components/login-page/Login'
import styled from 'styled-components/macro'

//@ts-ignore
import { useTheme } from 'styled-components'
import { FunctionComponent } from 'react'
import { BackendUser, UserRoles } from 'common/types'

const StyledBox = styled(Box)`
  background: linear-gradient(180deg, #e5e7e1, grey 46.49%, black);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
`
interface LoginPageProps {
  onConfirm: Function
  onClose: Function
  title: string
  tabIndex: number
  setSelectedTab: Function
  mode: UserRoles
  onLogin: Function
  username: string
  password: string
  setUsername: Function
  setPassword: Function
  selectedPage: number
  setSelectedPage: Function
  user: BackendUser
  confirmEmail?: Function
  errorCount?: number
  setErrorCount?: Function
  setShowTicketModal?: Function
  success?: boolean
  setSuccess?: Function
  setForwardingUrl?: Function
  timer: number
  setTimer: Function
  errorFlag: boolean
  setErrorFlag: Function
  errorMessage: string
  setErrorMessage: Function
  getItem: Function
  clearItem: Function
  showConfirmEmailModal: boolean
  setShowConfirmEmailModal: Function
  isLocked: boolean
  setIsLocked: Function
  handleUsernameChange: Function
  resendConfirmationCode: Function
}
const LandingPage: FunctionComponent<LoginPageProps> = ({
  title,
  tabIndex,
  setSelectedTab,
  onConfirm,
  onLogin,
  mode,
  username,
  password,
  setUsername,
  setPassword,
  selectedPage,
  setSelectedPage,
  user,
  confirmEmail,
  errorCount,
  setErrorCount,
  timer,
  setTimer,
  errorFlag,
  setErrorFlag,
  errorMessage,
  setErrorMessage,
  getItem,
  clearItem,
  showConfirmEmailModal,
  setShowConfirmEmailModal,
  isLocked,
  setIsLocked,
  handleUsernameChange,
  resendConfirmationCode
}) => {
  const { isDevice, } = useScreenSizes()
  const theme = useTheme()

  return (
    <Box display="flex" height="100%" style={{ backgroundColor: 'transparent' }}>
      {!isDevice && (<StyledBox width="50%">
        <img
          src="https://bptn-frontend-music-dev.s3.amazonaws.com/media/images/obsidi/banner_loginpage3.png"
          alt=""
          style={{ height: '95%', display: 'block', margin: '0 auto' }}
        />
      </StyledBox>)
      }
      <Box
        width={isDevice ? '100%' : '50%'}
        bgcolor={theme.colors.bgPrimary}
        display={isDevice ? '' : 'flex'}
        alignItems={isDevice ? '' : 'center'}
      >
        <Login
          showConfirmEmailModal={showConfirmEmailModal}
          setShowConfirmEmailModal={setShowConfirmEmailModal}
          username={username}
          password={password}
          setUsername={setUsername}
          setPassword={setPassword}
          title={title}
          tabIndex={tabIndex}
          setSelectedTab={setSelectedTab}
          mode={mode}
          onSubmit={onConfirm}
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
          onLogin={onLogin}
          user={user}
          confirmEmail={confirmEmail}
          errorCount={errorCount}
          setErrorCount={setErrorCount}
          timer={timer}
          setTimer={setTimer}
          errorFlag={errorFlag}
          setErrorFlag={setErrorFlag}
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
          getItem={getItem}
          clearItem={clearItem}
          isLocked={isLocked}
          setIsLocked={setIsLocked}
          handleUsernameChange={handleUsernameChange}
          resendConfirmationCode={resendConfirmationCode}
        />
      </Box>
    </Box>
  )
}

export default LandingPage
